import { render, staticRenderFns } from "./permission.vue?vue&type=template&id=04e74d4f&scoped=true&"
import script from "./permission.vue?vue&type=script&lang=js&"
export * from "./permission.vue?vue&type=script&lang=js&"
import style0 from "./permission.vue?vue&type=style&index=0&id=04e74d4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e74d4f",
  null
  
)

export default component.exports